
import { supabase } from '@/integrations/supabase/client';

export const usernameValidationService = {
  async isUsernameTaken(username: string): Promise<boolean> {
    if (!username || username.trim().length === 0) {
      return false;
    }

    try {
      const { data, error } = await supabase.rpc('is_username_taken', {
        username_to_check: username.trim().toLowerCase()
      });

      if (error) {
        console.error('Error checking username availability:', error);
        return true; // Assume taken if error occurs for safety
      }

      return data || false;
    } catch (error) {
      console.error('Error checking username availability:', error);
      return true; // Assume taken if error occurs for safety
    }
  },

  async validateUsername(username: string, currentUsername?: string): Promise<{ isValid: boolean; message?: string }> {
    if (!username || username.trim().length === 0) {
      return { isValid: false, message: 'Username is required' };
    }

    const trimmedUsername = username.trim();

    if (trimmedUsername.length < 3) {
      return { isValid: false, message: 'Username must be at least 3 characters long' };
    }

    if (trimmedUsername.length > 30) {
      return { isValid: false, message: 'Username must be 30 characters or less' };
    }

    // Check if username contains only allowed characters
    const usernameRegex = /^[a-zA-Z0-9_-]+$/;
    if (!usernameRegex.test(trimmedUsername)) {
      return { isValid: false, message: 'Username can only contain letters, numbers, underscores, and hyphens' };
    }

    // If it's the same as current username, it's valid
    if (currentUsername && trimmedUsername.toLowerCase() === currentUsername.toLowerCase()) {
      return { isValid: true };
    }

    // Check if username is taken
    const isTaken = await this.isUsernameTaken(trimmedUsername);
    if (isTaken) {
      return { isValid: false, message: 'This username is already taken. Please choose another one.' };
    }

    return { isValid: true };
  }
};
